import { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full bg-black text-white p-4 shadow z-50">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <a href="/" className="flex items-center space-x-2">
          <img src="/logo.png" alt="Logo" className="h-8 w-auto" />
          <span className="text-lg font-bold">Minilo AI Blog</span>
        </a>

        {/* Mobile Menu Button (Hidden on Desktop) */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden focus:outline-none"
          aria-label="Toggle Menu"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Navigation Links */}
        <ul
          className={`absolute md:static bg-blue-600 md:bg-transparent top-full left-0 w-full md:w-auto flex flex-col md:flex-row md:space-x-4 p-4 md:p-0 shadow-md md:shadow-none transition-all duration-300 ${
            isOpen ? "block" : "hidden"
          } md:flex`}
        >
          {[
            { path: "/", label: "Home" },
            { path: "/about", label: "About" },
            { path: "/contact", label: "Contact" },
            { path: "/disclaimer", label: "Disclaimer" },
            { path: "/privacy-policy", label: "Privacy Policy" },
            { path: "/terms", label: "Terms" },
          ].map((item, index) => (
            <li key={index} className="text-center md:text-left">
              <Link
                to={item.path}
                className="block md:inline hover:underline transition-colors"
                onClick={() => setIsOpen(false)} // Close menu on click
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
